import React from "react";
import { Avatar, Card, Switch } from "antd";
import ResponsiveTable from "../../../design-system/ResponsiveTable";
import { itemRender, onShowSizeChange } from "../../../commons/PaginationFunction";

import {
  doctor_thumb_01,
  doctor_thumb_02,
  doctor_thumb_03,
  doctor_thumb_04,
  doctor_thumb_05,
  patient1,
  patient2,
  patient3,
  patient4,
  patient5
} from "../../../commons/PanelImagepath";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
const AppointmentList = () => {
  const { t } = useTranslation("dashboard");
  const data = [
    {
      id: 1,
      DoctorName: "Dr. Ruby Perrin",
      Speciality: "Dental ",
      PatientName: "Charlene Reed",
      Earned: "$5000.00 ",
      Date: "27 Sep 2019",
      time: "11.00 AM - 11.15 AM",
      Amount: "$200.00",
      image: doctor_thumb_01,
      images1: patient1,
      Status: "checkbox"
    },
    {
      id: 2,
      DoctorName: "Dr. Darren Elder",
      Speciality: "Dental ",
      PatientName: "Travis Trimble",
      Earned: "$3300.00 ",
      Date: "1 Nov 2019",
      time: "11.00 PM - 11.35 PM",
      Amount: "$300.00",
      image: doctor_thumb_02,
      images1: patient2,
      Status: "checkbox"
    },
    {
      id: 3,
      DoctorName: "Dr. Deborah Angel",
      Speciality: "Cardiology ",
      PatientName: "Carl Kelly",
      Earned: "$4100.00",
      Date: "3 Nov 2019",
      time: "12.00 PM - 12.15 PM",
      Amount: "$150.00",
      image: doctor_thumb_03,
      images1: patient3,
      Status: "checkbox"
    },
    {
      id: 4,
      DoctorName: "Dr. Sofia Brient",
      Speciality: "Urology ",
      PatientName: "Michelle Fairfax",
      Earned: "$4000.00 ",
      Date: "16 Jun 2019",
      time: "1.00 PM - 1.20 PM",
      Amount: "$150.00",
      image: doctor_thumb_04,
      images1: patient4,
      Status: "checkbox"
    },
    {
      id: 5,
      DoctorName: "Dr. Marvin Campbell",
      Speciality: "Orthopaedics ",
      PatientName: "Gina Moore",
      Earned: "$2000.00 ",
      Date: "22 Aug 2019",
      time: "1.00 PM - 1.15 PM",
      Amount: "$200.00",
      image: doctor_thumb_05,
      images1: patient5,
      Status: "checkbox"
    }
  ];
  const columns = [
    {
      title: t("Doctor Name"),
      dataIndex: "DoctorName",
      render: (text, record) => (
        <Link to="/admin/profile" className="subadmin-dashboard__person">
          <Avatar size={32} src={record.image} alt="" />
          <span>{text}</span>
        </Link>
      ),
      sorter: (a, b) => a.DoctorName.length - b.DoctorName.length
    },
    {
      title: t("Speciality"),
      dataIndex: "Speciality",
      sorter: (a, b) => a.Speciality.length - b.Speciality.length
    },

    {
      title: t("Patient Name"),
      dataIndex: "PatientName",
      render: (text, record) => (
        <Link to="/admin/profile" className="subadmin-dashboard__person">
          <Avatar size={32} src={record.images1} alt="" />
          <span>{text}</span>
        </Link>
      ),
      sorter: (a, b) => a.PatientName.length - b.PatientName.length
    },

    {
      title: t("Apointment Time"),
      render: record => (
        <>
          <div>{record.Date}</div>
          <div className="subadmin-dashboard__muted">{record.time}</div>
        </>
      ),
      sorter: (a, b) => a.Date.length - b.time.length
    },
    {
      title: t("Status"),
      dataIndex: "Status",
      render: () => <Switch size="small" defaultChecked={false} aria-label={t("Status")} />,
      sorter: (a, b) => a.Status.length - b.Status.length
    },
    {
      title: t("Amount"),
      dataIndex: "Amount",
      sorter: (a, b) => a.Amount.length - b.Amount.length
    }
  ];
  return (
    <Card title={t("Appointment List")} className="subadmin-dashboard__card">
      <ResponsiveTable
        pagination={{
          total: data.length,
          showTotal: (total, range) =>
            t("pagination.showTotal", {
              rangeStart: range[0],
              rangeEnd: range[1],
              total
            }),
          showSizeChanger: true,
          onShowSizeChange: onShowSizeChange,
          itemRender: itemRender
        }}
        columns={columns}
        dataSource={data}
        rowKey={record => record.id}
      />
    </Card>
  );
};
export default AppointmentList;
